import axios from "axios";

// const Base_URL = "https://";

// Add once (top of file):
const normalizeForSimple = (term) => {
    const t = (term ?? "").trim();
    const needsQuotes = /\s|["()]/.test(t);
    const escaped = t.replace(/"/g, '\\"');
    return needsQuotes ? `"${escaped}"` : t;
};
class BackendService {

    async TextTranslation(inputText) {
        const translationEndpoint = "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0";
        const subscriptionKey = "2T4DJeeQcZ1H66qJ4xisa2pSrIdKrr5OmBJQt6l46JlIdc5RxRfBJQQJ99BHACPV0roXJ3w3AAAAACOGlYmj";
        const region = "germanywestcentral";

        // FIX: use real '&'
        const queryParams = '&to=en&to=fr&to=de&to=pl&to=es';

        // FIX: inputText can be a string or {searchText}; normalize to string
        const text = typeof inputText === "string" ? inputText : String(inputText?.searchText ?? "");

        const requestBody = [{ Text: text }];
        console.log('Translating text:', text);

        try {
            const response = await axios.post(`${translationEndpoint}${queryParams}`, requestBody, {
                headers: {
                    'Ocp-Apim-Subscription-Key': subscriptionKey,
                    'Ocp-Apim-Subscription-Region': region,
                    'Content-Type': 'application/json'
                }
            });

            // FIX: Translator v3 returns an array
            const item = Array.isArray(response.data) ? response.data[0] : response.data;

            const translations = Array.isArray(item?.translations) ? item.translations : [];
            const terms = translations.map(t => t.text).filter(Boolean);

            // Include original if detected source language is NOT one of the 'to' languages
            let detectedInTargets = false;
            for (let i = 0; i < translations.length; i++) {
                if (item.detectedLanguage?.language === translations[i].to) {
                    detectedInTargets = true;
                    break;
                }
            }
            if (!detectedInTargets && text) {
                terms.unshift(text);
            }

            return terms; // array of strings
        } catch (error) {
            console.error('Error during text translation:', error);
            throw error;
        }
    }

    AzureAiV2(terms, filter, skip) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        // FIX: expect an array of terms here
        if (!Array.isArray(terms)) {
            throw new Error("AzureAiV2 requires an array of terms.");
        }

        const uniqueTerms = Array.from(new Set(terms.map(s => String(s).trim()).filter(Boolean)));
        let searchExpr;
        if (uniqueTerms.length === 0) {
            searchExpr = "*";
        } else {
            searchExpr = `(${uniqueTerms.map(normalizeForSimple).join(" OR ")})`;
        }

        const requestBody = {
            search: searchExpr,
            queryType: "full", // required for phrase search
            searchMode: "all",
            skip: skip,
            top: 1000,
            count: true
        };

        if (filter) {
            requestBody.filter = filter;
        }

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return search results
        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    FetchDropdownData() {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "projectId,count:1000000",
                "supplier/name,count:1000000",
                // "regions/name,count:1000000",
                // "commodities/name,count:1000000",
                "signingLegalEntity,count:1000000",
                "contractType,count:1000000",
                "paymentTerms,count:1000000",
                "parentAgreement,count:1000000",
                "stdClauses/clauseLabel,count:1000000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchRegionsDropdownData() {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "index-region-master";
        // const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "index-scauat-region-master";
        const apiVersion = "2025-05-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "HierarchyPath_Description,count:10000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            console.log('FetchRegionsDropdownData response:', response);

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchCommoditiesDropdownData() {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "index-master-data";
        // const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "index-scauat-commodity-master";
        const apiVersion = "2025-05-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "HierarchyPath_Description,count:10000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            console.log('FetchRegionsDropdownData response:', response);

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    AzureAiV2Autocomplete(query, suggesterName) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            search: query,
            suggesterName: suggesterName,
            autocompleteMode: "oneTermWithContext"
        };

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/autocomplete?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return autocomplete results
        } catch (error) {
            console.error('Error fetching autocomplete results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    AzureAiV2Suggest(query, suggesterName) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            search: query,
            suggesterName: suggesterName,
            top: 5,
        };

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/suggest?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return suggestion results
        } catch (error) {
            console.error('Error fetching suggestion results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchReportToken() {
        const endpoint = "https://api.powerbi.com/v1.0/myorg/groups/{groupId}/reports/{reportId}/GenerateToken";

        try {
            const response = axios.post(`${endpoint}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }
}

const backendService = new BackendService();

export default backendService;
